import BaseEvent from './base_event';

export default class RoboRomanceEvent extends BaseEvent {

    static canOccur() { return true;}

    enter(gameState) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'RoboRomanceEvents');

        let next = (breakLeg) => () => {
            if (breakLeg) {
                gameState.hero.addFactor(0.6);// speed = gameState.hero.speed * 0.6;
            }
            this.ui.showDialog({
                message: breakLeg ? "You kicked his shiny metal ass! For no effect. Except your leg is broken now" : ""
                    + ("\n For some reason, droid stops right in front of Jenkins. His red eye turns green and it beeps " +
                    "something illegible"),
                status: breakLeg ? "Speed decreased" : undefined,
                options: [{
                    text: "Continue watching",
                    callback: () => {
                        gameState.history.push({ id: 'jnk', msg: `witnessed a roboromance` });
                        this.ui.showDialog({
                            message: `- Yes, of course, - murmured Jenkins.\n - Beep, beep, beep, - said droid\n - I love you too, - replied Jenkins\nAnd just like that both of them went through the airlock and vanished among the shining stars...`,
                            status: 'Jenkins left the ship',
                        }, () => {
                            gameState.remove('jenkins');
                            gameState.remove('madjenkins');
                            gameState.remove('robo-alien');
                            this.end();
                        });
                    }
                }]
            })
        };


        this.ui.showDialog({
            message: "Oh no! Damn droid has aimed on Jenkins!",
            options: [{
                text: "Kick the droid with all your might",
                callback: next(true)
            },{
                text: '"- Jenkins, duck and cover!"',
                callback: next()
            },{
                text: "Just watch what happens next",
                callback: next()
            }]
        })
    }
}


// WEBPACK FOOTER //
// ./src/states/events/robo_romance.js